import {
  ALL_CATEGORY,
  TODAY_SPECIAL_CATEGORY,
} from "../components/product/productDashboard";
import { Product, STORE_CURRENCY_POSITION } from "../components/types/product";

export const isEmpty = (data: any) => {
  if (!data) return true;
  if (Array.isArray(data)) return !data?.length;
  else if (typeof data === "object") return !Object.keys(data)?.length;
  return false;
};

export const filterProducts = (
  products: Product[],
  productCategory: Product["category"],
  keyword: string
) => {
  return products.filter((product: Product) => {
    if (!keyword)
      return (
        productCategory === ALL_CATEGORY ||
        (productCategory === TODAY_SPECIAL_CATEGORY &&
          Boolean(product.today_special)) ||
        product.category === productCategory
      );

    //else
    return product?.name?.toLowerCase()?.includes(keyword?.toLowerCase());
  });
};

export const appendCurrency = (price?: string) => {
  if (!price) return price;
  const CURRENCY = window["$currency"];
  const CURRENCY_POSITION = window["$currency_position"];

  return `${
    CURRENCY_POSITION === STORE_CURRENCY_POSITION.before
      ? `${CURRENCY} ${price}`
      : `${price} ${CURRENCY}`
  }`;
};

export const resolveImgSrc = (relativePath: string) => {
  return `/uploads/${relativePath}`;
};
